import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { DataService } from '../data.service';
import { NotificationService } from '../notification.service';
import { Module, NotificationMessage, PermessionType, ToastType } from '../../models/enumeration-list.model';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(private dataService: DataService, private router: Router, public notificationService: NotificationService) { }
  private alreadyRedirected = false;
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const requiredRoles = route.data['roles'] as string[];
    const perm = route.data['permsision'] as PermessionType;
    const module = Module[this.dataService.getBasePath(route.routeConfig.path)]


    return this.dataService.prepareUserData().pipe(
      tap((userData) => {
        if (userData) {
          this.dataService.setProfileInformations(userData);
        }
      }),
      switchMap(() => {
        const profileAddressId = sessionStorage.getItem('profileAddressId');
        const profileId = sessionStorage.getItem('profileId');
        return this.dataService.loadUserRole(profileAddressId, profileId).pipe(
          map((userRoleData) => {
            const { roles, permissions } = userRoleData || {};
            if (roles?.length) {
              this.dataService.setRole(roles);
              if (this.dataService.hasPermessionForSpecificModule(module, perm)) {

                return true;
              }
              if (route.routeConfig?.path === 'companies') {

                this.router.navigate(['/login']);
                return false;
              }
              if (!this.alreadyRedirected) {
                this.alreadyRedirected = true;
                this.dataService.unothorized = true;
                this.router.navigate(['/unauthorized']);
                return false;
              }
            } else {

              if (!this.alreadyRedirected) {
                this.alreadyRedirected = true;

                this.router.navigate(['/login']);
                return false;
              }
            }
          }),
          catchError((error) => {

            if (!this.alreadyRedirected) {
              this.alreadyRedirected = true;

              this.router.navigate(['/unauthorized']);
            }
            return of(false);
          })
        );
      }),
      catchError((error) => {

        if (!this.alreadyRedirected) {
          this.alreadyRedirected = true;

          this.router.navigate(['/login']);
        }
        return of(false);
      })
    );
  }

}


